document.addEventListener("DOMContentLoaded", function () {
  // =========================
  // Aria expanded js
  // =========================
  document.querySelectorAll("button.nav-dropdown-title").forEach((btn) => {
    const parent = btn.closest(".nav-dropdown");

    const updateAria = () => {
      const isOpen = parent.classList.contains("opened");
      btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    };
    updateAria();
    const observer = new MutationObserver(updateAria);
    observer.observe(parent, { attributes: true, attributeFilter: ["class"] });
  });

  // =========================
  // Blog pagination fixes
  // =========================
  document.querySelectorAll(".paginate-total .page a").forEach(function (link) {
    var pageNumber = link.textContent.trim();

    if (pageNumber) {
      link.setAttribute("aria-label", "Page " + pageNumber);
    }
  });

  document
    .querySelectorAll(".paginate-total .page.current")
    .forEach(function (currentPage) {
      var pageNumber = currentPage.textContent.trim();

      if (pageNumber) {
        currentPage.setAttribute("aria-current", "page");
        currentPage.setAttribute("aria-label", "Page " + pageNumber);
      }
    });

  document.querySelectorAll(".paginate-total .prev a").forEach(function (link) {
    link.setAttribute("aria-label", "Previous page");
  });

  document.querySelectorAll(".paginate-total .next a").forEach(function (link) {
    link.setAttribute("aria-label", "Next page");
  });

  // =========================
  // Email & phone labels
  // =========================

  document
    .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
    .forEach(function (el) {
      const href = el.getAttribute("href");
      if (
        el.getAttribute("role") === "button" ||
        el.classList.contains("button") ||
        el.classList.contains("btn")
      ) {
        return;
      }

      if (href && href.startsWith("mailto:")) {
        const email = href.replace("mailto:", "").trim();
        const existing = el.getAttribute("aria-label");

        if (existing) {
          el.setAttribute("aria-label", existing + ", Email address: " + email);
        } else {
          el.setAttribute("aria-label", "Email address: " + email);
        }
      }

      // TEL
      if (href && href.startsWith("tel:")) {
        const text = el.textContent.trim();
        const existing = el.getAttribute("aria-label");

        if (existing) {
          el.setAttribute("aria-label", existing + ", Phone number: " + text);
        } else {
          el.setAttribute("aria-label", "Phone number: " + text);
        }
      }
    });

  // =========================
  // Third party warning
  // =========================
  const warningText =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";
        if (!alt.includes(warningText)) {
          img.setAttribute("alt", alt ? alt + ", " + warningText : warningText);
        }
        return;
      }

      const text = link.textContent.trim();
      if (!text) return;

      const aria = link.getAttribute("aria-label");
      if (!aria || !aria.includes(warningText)) {
        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =========================
  // internal links fixes
  // =========================
  function isInternalLink(href) {
    try {
      const linkUrl = new URL(href, window.location.href);
      return linkUrl.hostname === window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function removeTargetRelFromInternalLinks() {
    document
      .querySelectorAll('a[target="_blank"], a[rel]')
      .forEach(function (link) {
        const href = link.getAttribute("href");

        if (!href) return;
        if (
          href.startsWith("mailto:") ||
          href.startsWith("tel:") ||
          href.startsWith("#") ||
          href.startsWith("javascript:")
        ) {
          return;
        }
        if (isInternalLink(href)) {
          link.removeAttribute("target");
          link.removeAttribute("rel");
        }
      });
  }
  removeTargetRelFromInternalLinks();

  // =====================================
  // Adding aria-hidden true on slick track
  // =====================================
  function hideSlickDotsFromScreenReaders() {
    document.querySelectorAll(".slick-dots").forEach(function (dots) {
      dots.setAttribute("aria-hidden", "true");
      dots.setAttribute("tabindex", "-1");
    });
  }

  hideSlickDotsFromScreenReaders();

  if (window.jQuery) {
    window
      .jQuery(document)
      .on("init reInit afterChange", ".slick-slider", function () {
        hideSlickDotsFromScreenReaders();
      });
  }

  // =========================
  // Homepage carousel previous and next buttons
  // =========================
  const carousel = document.querySelector(
    ".hp-module-a .carousel-content.slick",
  );
  const previousButton = document.querySelector(
    ".hp-module-a .carousel-previous",
  );
  const nextButton = document.querySelector(".hp-module-a .carousel-next");

  if (carousel && previousButton && nextButton && window.jQuery) {
    const $carousel = window.jQuery(carousel);

    function updateCarouselArrows(event, slick, currentSlide) {
      if (!slick && $carousel.hasClass("slick-initialized")) {
        slick = $carousel.slick("getSlick");
      }

      if (!slick) return;

      const index =
        typeof currentSlide === "number" ? currentSlide : slick.currentSlide;

      previousButton.disabled = index === 0;
      nextButton.disabled = index >= slick.slideCount - 1;
    }

    previousButton.addEventListener("click", function () {
      $carousel.slick("slickPrev");
    });

    nextButton.addEventListener("click", function () {
      $carousel.slick("slickNext");
    });

    $carousel.on("init reInit afterChange", updateCarouselArrows);
    updateCarouselArrows();
  }
  // Pause homepage carousel by default after Slick initializes
  function pauseHomepageCarousel() {
    const $carousel = window.jQuery(".hp-module-a .carousel-content.slick");
    const $playPause = window.jQuery(".hp-module-a .carousel-play-pause");

    if (!$carousel.hasClass("slick-initialized")) {
      setTimeout(pauseHomepageCarousel, 100);
      return;
    }

    $carousel.slick("slickPause");
    $playPause
      .attr("data-action", "play")
      .attr("aria-label", "Play carousel")
      .removeClass("is-playing");
  }

  if (window.jQuery) {
    pauseHomepageCarousel();
  }

  // Search close button focus return
  let lastSearchTrigger = null;
  const rememberSearchTrigger = (t) =>
  (lastSearchTrigger =
    t?.closest?.("header .search-toggle") || lastSearchTrigger);
  const closeSearchAndReturnFocus = (s) => {
    const d =
      s.closest("#SearchBar") || document.querySelector("#SearchBar.opened");
    const i =
      s.closest(".block-search") ||
      document.querySelector(".block-search.active");
    if (!d && !i) return false;
    const r = i ? i.querySelector(".search-toggle") : lastSearchTrigger;
    d?.classList.remove("opened", "open", "active");
    d?.setAttribute("aria-hidden", "true");
    i?.classList.remove("active");
    document.body.classList.remove("show-overlay", "drawer-opt");
    document.querySelectorAll(".search-toggle").forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false");
    });
    requestAnimationFrame(() =>
      requestAnimationFrame(
        () => r && document.contains(r) && r.focus({ preventScroll: true }),
      ),
    );
    return true;
  };
  document.addEventListener(
    "click",
    (e) => {
      rememberSearchTrigger(e.target);
      const c = e.target.closest(".close-search-btn");
      if (c && closeSearchAndReturnFocus(c)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true,
  );
  document.addEventListener(
    "keydown",
    (e) => {
      rememberSearchTrigger(e.target);
      if (e.key !== "Escape") return;
      const a =
        e.target.closest("#SearchBar, .block-search") ||
        document.querySelector("#SearchBar.opened, .block-search.active");
      if (a && closeSearchAndReturnFocus(a)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true,
  );

  // Search dialog focus management
  (function () {
    const searchDialog = document.querySelector("#SearchBar");

    if (!searchDialog) return;

    const SEARCH_DIALOG_OPEN_CLASS = "opened";
    const FOCUSABLE_SELECTOR =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const SEARCH_AUTOCOMPLETE_SELECTOR = ".snize-ac-results";
    const SEARCH_WIDGET_OPEN_CLASS = "snize-instant-widget-is-open";

    const isRendered = (element) =>
      !!(
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
      );
    const isModalSearchPanel = (panel) =>
      document.body.classList.contains(SEARCH_WIDGET_OPEN_CLASS) ||
      !!panel.querySelector('input[type="search"], input[name="q"]');

    const getRenderedSearchPanels = () =>
      Array.from(
        document.querySelectorAll(SEARCH_AUTOCOMPLETE_SELECTOR),
      ).filter((panel) => isRendered(panel) && !searchDialog.contains(panel));

    const getTrappedContainers = () => {
      const isDialogOpen = searchDialog.classList.contains(
        SEARCH_DIALOG_OPEN_CLASS,
      );
      const panels = getRenderedSearchPanels();

      const trappablePanels = isDialogOpen
        ? panels
        : panels.filter(isModalSearchPanel);

      return [...(isDialogOpen ? [searchDialog] : []), ...trappablePanels];
    };

    const CLOSE_BUTTON_SELECTOR = ".close-search-btn, .snize-close-button";

    const moveCloseButtonsLast = (elements) => {
      const closeButtons = elements.filter((element) =>
        element.matches(CLOSE_BUTTON_SELECTOR),
      );

      if (!closeButtons.length) return elements;

      return [
        ...elements.filter((element) => !closeButtons.includes(element)),
        ...closeButtons,
      ];
    };

    // Hidden elements are still matched by the selector, so filter by rendered box
    const getVisibleFocusableElements = (containers) =>
      moveCloseButtonsLast(
        containers.flatMap((container) =>
          Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
            isRendered,
          ),
        ),
      );

    // The drawer animates open, so focus only sticks after the next paint
    const focusAfterPaint = (element) => {
      if (!element || !document.contains(element)) return;

      requestAnimationFrame(() =>
        requestAnimationFrame(() => element.focus({ preventScroll: true })),
      );
    };

    const isSearchDialogOpen = () =>
      searchDialog.classList.contains(SEARCH_DIALOG_OPEN_CLASS);

    // The close control is a span[role="button"], so it is not focusable by default
    const makeSearchCloseButtonFocusable = () => {
      searchDialog
        .querySelectorAll(".close-search-btn")
        .forEach((closeButton) => {
          if (!closeButton.hasAttribute("tabindex")) {
            closeButton.setAttribute("tabindex", "0");
          }
        });
    };

    const focusSearchInput = () => {
      const searchInput = searchDialog.querySelector('input[type="search"]');

      focusAfterPaint(
        searchInput ||
        getVisibleFocusableElements([searchDialog])[0] ||
        searchDialog,
      );
    };

    makeSearchCloseButtonFocusable();

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Tab") return;

      const trappedContainers = getTrappedContainers();
      const focusableElements = getVisibleFocusableElements(trappedContainers);

      if (!focusableElements.length) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      const isFocusTrapped = trappedContainers.some((container) =>
        container.contains(activeElement),
      );

      if (!isFocusTrapped) {
        event.preventDefault();
        (event.shiftKey ? lastElement : firstElement).focus({
          preventScroll: true,
        });
        return;
      }

      if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus({ preventScroll: true });
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus({ preventScroll: true });
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      const closeButton = event.target.closest("#SearchBar .close-search-btn");

      if (!closeButton) return;

      event.preventDefault();
      closeButton.click();
    });

    window.addEventListener(
      "keydown",
      (event) => {
        if (event.key !== "Escape") return;
        if (!getRenderedSearchPanels().some(isModalSearchPanel)) return;

        if (typeof window.Searchanise?.AutocompleteCloseAll !== "function") {
          return;
        }

        window.Searchanise.AutocompleteCloseAll();
        focusAfterPaint(document.querySelector("header .search-toggle"));
      },
      true,
    );

    let wasSearchDialogOpen = isSearchDialogOpen();

    const syncSearchAriaState = (isOpen) => {
      searchDialog.setAttribute("aria-hidden", String(!isOpen));
      document.querySelectorAll(".search-toggle").forEach((toggle) => {
        toggle.setAttribute("aria-controls", searchDialog.id);
        toggle.setAttribute("aria-expanded", String(isOpen));
      });
    };

    syncSearchAriaState(wasSearchDialogOpen);

    const searchDialogObserver = new MutationObserver(() => {
      const isOpen = isSearchDialogOpen();

      syncSearchAriaState(isOpen);
      makeSearchCloseButtonFocusable();

      if (isOpen && !wasSearchDialogOpen) {
        focusSearchInput();
      }

      wasSearchDialogOpen = isOpen;
    });

    searchDialogObserver.observe(searchDialog, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
    });

    if (wasSearchDialogOpen) {
      focusSearchInput();
    }
  })();

  //slider reading sequnece fix issues
  function updateScrollableSliderA11y() {
    document
      .querySelectorAll(".slider-container.items .drag-to-scroll")
      .forEach(function (slider) {
        const sliderRect = slider.getBoundingClientRect();

        slider
          .querySelectorAll(".product-grid-item, .block")
          .forEach(function (slide) {
            const rect = slide.getBoundingClientRect();
            const visible =
              rect.right > sliderRect.left && rect.left < sliderRect.right;

            slide.setAttribute("aria-hidden", visible ? "false" : "true");

            slide
              .querySelectorAll(
                "a, button, input, select, textarea, [tabindex]",
              )
              .forEach(function (el) {
                // Ignore product tile overlay link
                if (el.classList.contains("product-tile__overlay-link")) {
                  return;
                }

                el.setAttribute("tabindex", visible ? "0" : "-1");
              });
          });
      });
  }

  updateScrollableSliderA11y();

  document
    .querySelectorAll(".slider-container.items .drag-to-scroll")
    .forEach(function (slider) {
      slider.addEventListener("scroll", updateScrollableSliderA11y, {
        passive: true,
      });
    });

  window.addEventListener("resize", updateScrollableSliderA11y);
  setTimeout(updateScrollableSliderA11y, 500);
  function fixProductPriceLabels() {
    document.querySelectorAll(".price-box").forEach(function (priceBox) {
      var productPrice = priceBox.querySelector(".product-price");
      var comparePrice = priceBox.querySelector(".product-compare-price");
      var hasSpecialPrice = priceBox.classList.contains("has-special");

      if (!productPrice && priceBox.textContent.trim()) {
        var priceText = priceBox.textContent.replace(/\s+/g, " ").trim();

        priceBox.innerHTML =
          '<span class="h2 product-price" itemprop="price">' +
          priceText +
          "</span>";

        productPrice = priceBox.querySelector(".product-price");
        comparePrice = priceBox.querySelector(".product-compare-price");
      }

      if (productPrice && !productPrice.querySelector(".sr-only")) {
        var productPriceText = productPrice.textContent
          .replace(/\s+/g, " ")
          .trim();

        var labelText = "Regular price:";

        if (
          productPriceText.indexOf("-") !== -1 ||
          productPriceText.indexOf("From:") !== -1
        ) {
          labelText = "Price range:";
        } else if (hasSpecialPrice) {
          labelText = "Sale price:";
        }

        var priceLabel = document.createElement("span");
        priceLabel.className = "sr-only";
        priceLabel.textContent = labelText + " ";
        productPrice.insertBefore(priceLabel, productPrice.firstChild);
      }

      if (comparePrice && !comparePrice.querySelector(".sr-only")) {
        var compareLabel = document.createElement("span");
        compareLabel.className = "sr-only";
        compareLabel.textContent = "Original price: ";
        comparePrice.insertBefore(compareLabel, comparePrice.firstChild);
      }
    });
  }

  fixProductPriceLabels();

  var priceLabelObserver = new MutationObserver(function () {
    fixProductPriceLabels();
  });

  priceLabelObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  //h1 for screen reader users
  if (window.location.pathname === "/pages/collections") {
    var main =
      document.querySelector("main") || document.querySelector("#MainContent");

    if (main && !main.querySelector("h1")) {
      var h1 = document.createElement("h1");
      h1.textContent = "Collection All";
      h1.className = "sr-only";
      main.insertBefore(h1, main.firstChild);
    }
  }

  // Mobile menu focus management
  (function () {
    var mobileNav = document.querySelector("#MobileNav");
    var lastMenuTrigger = null;
    var lastSubmenuTrigger = null;

    if (!mobileNav) return;

    function getFocusable(container) {
      return Array.prototype.slice
        .call(
          container.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
          ),
        )
        .filter(function (el) {
          return !!(
            el.offsetWidth ||
            el.offsetHeight ||
            el.getClientRects().length
          );
        });
    }

    function focusElement(el) {
      if (!el || !document.contains(el)) return;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.focus({ preventScroll: true });
        });
      });
    }

    function getMenuButton() {
      return (
        document.querySelector(".block-title.menu-toggle") ||
        lastMenuTrigger ||
        document.querySelector("header .menu-toggle") ||
        document.querySelector(".menu-toggle")
      );
    }

    function closeMobileDrawer() {
      mobileNav.classList.remove("opened", "open", "active");

      document.querySelectorAll(".menu-toggle").forEach(function (button) {
        button.setAttribute("aria-expanded", "false");

        button
          .querySelectorAll(".animated-hamburger.open, span.open")
          .forEach(function (span) {
            span.classList.remove("open", "opened");
          });
      });

      if (lastSubmenuTrigger && document.contains(lastSubmenuTrigger)) {
        lastSubmenuTrigger.setAttribute("aria-expanded", "false");
      }

      focusElement(getMenuButton());
    }

    function addMobileMenuAttributes() {
      mobileNav.setAttribute("role", "dialog");
      mobileNav.setAttribute("aria-label", "Mobile navigation");
      mobileNav.setAttribute("aria-haspopup", "true");

      var siteNav = mobileNav.querySelector(".inner-wrapper .site-nav");

      if (siteNav) {
        siteNav.setAttribute("role", "dialog");
        siteNav.setAttribute("aria-label", "Mobile menu");
        siteNav.setAttribute("aria-haspopup", "true");
      }

      addActiveSubmenuDialogAttributes();
    }
    function updateLevel2AriaExpanded() {
      document
        .querySelectorAll(
          "#MobileNav .level-2.has-children.expandable > .nav-link[aria-expanded]",
        )
        .forEach(function (link) {
          var parentLi = link.closest(".level-2.has-children.expandable");

          link.setAttribute(
            "aria-expanded",
            parentLi && parentLi.classList.contains("active")
              ? "true"
              : "false",
          );
        });
    }

    function addMobileCloseButton() {
      if (mobileNav.querySelector(".mobile-menu-close-a11y")) return;

      var closeButton = document.createElement("button");
      closeButton.type = "button";
      closeButton.className = "mobile-menu-close-a11y sr-only";
      closeButton.textContent = "Close mobile menu";

      var navBar = mobileNav.querySelector(".nav-bar");

      if (navBar) {
        navBar.insertBefore(closeButton, navBar.firstChild);
      } else {
        mobileNav.insertBefore(closeButton, mobileNav.firstChild);
      }

      closeButton.addEventListener("click", closeMobileDrawer);
    }

    function addActiveSubmenuDialogAttributes() {
      mobileNav
        .querySelectorAll(".children.dropdown.column-layout.active")
        .forEach(function (submenu) {
          submenu.setAttribute("role", "dialog");
          submenu.setAttribute("aria-label", "Mobile submenu");
          submenu.setAttribute("aria-haspopup", "true");

          if (!submenu.querySelector(".mobile-submenu-close-a11y")) {
            var closeButton = document.createElement("button");
            closeButton.type = "button";
            closeButton.className = "mobile-submenu-close-a11y sr-only";
            closeButton.textContent = "Close mobile menu";

            submenu.insertBefore(closeButton, submenu.firstChild);

            closeButton.addEventListener("click", closeMobileDrawer);
          }
        });
    }

    function focusFirstMobileMenuItem() {
      var focusable = getFocusable(mobileNav);
      focusElement(focusable[0] || mobileNav);
    }

    function focusActiveSubmenu(trigger) {
      var targetId = trigger && trigger.getAttribute("data-trigger");
      var submenu = null;

      if (targetId) {
        submenu = mobileNav.querySelector(
          '.children.dropdown[data-target="' + targetId + '"]',
        );
      }

      submenu =
        submenu ||
        mobileNav.querySelector(".children.dropdown.active") ||
        mobileNav.querySelector(".slide-in-menu .children.dropdown");

      if (!submenu) return;

      addActiveSubmenuDialogAttributes();

      var backButton =
        submenu.querySelector(".back-to a") ||
        submenu.querySelector(".back-to");

      if (backButton && !backButton.hasAttribute("tabindex")) {
        backButton.setAttribute("tabindex", "0");
      }

      focusElement(backButton || getFocusable(submenu)[0]);
    }

    addMobileMenuAttributes();
    addMobileCloseButton();
    updateLevel2AriaExpanded();

    document.addEventListener(
      "click",
      function (event) {
        var menuTrigger = event.target.closest(".menu-toggle");

        if (menuTrigger) {
          lastMenuTrigger = menuTrigger;

          setTimeout(function () {
            if (mobileNav.classList.contains("opened")) {
              focusFirstMobileMenuItem();
            }
          }, 150);

          return;
        }

        var submenuTrigger = event.target.closest(
          "#MobileNav .level-1.has-children > .nav-link[data-trigger]",
        );

        if (submenuTrigger) {
          lastSubmenuTrigger = submenuTrigger;

          setTimeout(function () {
            submenuTrigger.setAttribute("aria-expanded", "true");
            addActiveSubmenuDialogAttributes();
            focusActiveSubmenu(submenuTrigger);
          }, 150);

          return;
        }

        var backButton = event.target.closest("#MobileNav .back-to");

        if (backButton) {
          setTimeout(function () {
            if (lastSubmenuTrigger && document.contains(lastSubmenuTrigger)) {
              lastSubmenuTrigger.setAttribute("aria-expanded", "false");
              focusElement(lastSubmenuTrigger);
            } else {
              focusFirstMobileMenuItem();
            }
          }, 150);
        }
      },
      true,
    );

    document.addEventListener(
      "keydown",
      function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;

        var submenuTrigger = event.target.closest(
          "#MobileNav .level-1.has-children > .nav-link[data-trigger]",
        );

        if (submenuTrigger) {
          lastSubmenuTrigger = submenuTrigger;

          setTimeout(function () {
            submenuTrigger.setAttribute("aria-expanded", "true");
            addActiveSubmenuDialogAttributes();
            focusActiveSubmenu(submenuTrigger);
          }, 150);
        }

        var backButton = event.target.closest("#MobileNav .back-to");

        if (backButton) {
          setTimeout(function () {
            if (lastSubmenuTrigger && document.contains(lastSubmenuTrigger)) {
              lastSubmenuTrigger.setAttribute("aria-expanded", "false");
              focusElement(lastSubmenuTrigger);
            }
          }, 150);
        }
      },
      true,
    );

    var mobileMenuObserver = new MutationObserver(function () {
      var isOpen = mobileNav.classList.contains("opened");

      addMobileMenuAttributes();
      addMobileCloseButton();
      addActiveSubmenuDialogAttributes();
      updateLevel2AriaExpanded();

      document.querySelectorAll(".menu-toggle").forEach(function (button) {
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });

      if (!isOpen) {
        focusElement(getMenuButton());
      }
    });

    mobileMenuObserver.observe(mobileNav, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
    });
  })();

  //powermapper issues flagging
  (function () {
    function updateProductTileOverlayLinks() {
      document
        .querySelectorAll(".product-tile__overlay-link")
        .forEach(function (link) {
          link.setAttribute("tabindex", "-1");
        });
    }

    updateProductTileOverlayLinks();

    const observer = new MutationObserver(function () {
      updateProductTileOverlayLinks();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  })();

  // pagination label on span
  document
    .querySelectorAll(".paginate-total .page.current")
    .forEach(function (item) {
      item.removeAttribute("aria-label");
    });
  //aria-hidden true on br tag 
  document.querySelectorAll('br').forEach(function (br) {
    br.setAttribute('aria-hidden', 'true');
  });

  //filter focus issue
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    const dropdown = event.target.closest(
      ".filter.nav-dropdown.opened, " +
      ".collection-nav-block.sorting.nav-dropdown.opened"
    );
    if (!dropdown) return;

    const button = dropdown.querySelector(
      "button.filter-title, button.nav-title"
    );
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    dropdown.classList.remove("opened");
    button.setAttribute("aria-expanded", "false");
    button.focus();
  });

  (() => {
    const selector =
      ".pdp-content .accordion-container.tab-accordion-system button.system-title";

    document.addEventListener("click", function (event) {
      const button = event.target.closest(selector);
      if (!button) return;

      const item = button.closest(".system");
      const accordion = button.closest(".tab-accordion-system");
      const shouldOpen = !item.classList.contains("active");

      event.preventDefault();
      event.stopImmediatePropagation();

      // Close siblings and toggle the selected accordion.
      Array.from(accordion.children).forEach(function (sibling) {
        if (!sibling.classList.contains("system")) return;

        const open = sibling === item && shouldOpen;
        sibling.classList.toggle("active", open);

        const title = sibling.querySelector("button.system-title");
        if (title) title.setAttribute("aria-expanded", String(open));
      });
    }, true);

    // Allow native button keyboard activation without double toggling. for the product toggle 
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      if (!event.target.closest(selector)) return;

      event.stopImmediatePropagation();
    }, true);

    console.log(
      "Product accordion buttons found:",
      document.querySelectorAll(selector).length
    );
  })();

  //================= END ===============//
});
